import { useSelector } from 'react-redux';
import { getUserPanelRole, getUserSelectedSite } from 'selectors';
import { checkUserPanelAccess } from 'helpers/dashboard';

const AnalyticsHeader = () => {
  const panel_role = useSelector(getUserPanelRole);
  const userSelectedSite = useSelector(getUserSelectedSite);
  return (
    checkUserPanelAccess(panel_role) && (
      <h3>
        Analytics{' '}
        {userSelectedSite.includes('all')
          ? ''
          : `- ${userSelectedSite.map((site) => site.charAt(0).toUpperCase() + site.slice(1)).join(', ')}`}
      </h3>
    )
  );
};

export default AnalyticsHeader;
